import { FieldErrors } from 'react-hook-form';

export const flattenErrors = (
  errors: FieldErrors<Record<string, unknown>>,
  prefix = '',
  filterPath?: string,
): string[] => {
  const messages: string[] = [];

  for (const [key, value] of Object.entries(errors)) {
    const path = prefix ? `${prefix}.${key}` : key;

    if (value?.message && (!filterPath || path.startsWith(filterPath))) {
      messages.push(value.message as string);
    } else if (value && typeof value === 'object' && !Array.isArray(value)) {
      // Recursively flatten nested errors

      messages.push(
        ...flattenErrors(
          value as FieldErrors<Record<string, unknown>>,
          path,
          filterPath,
        ),
      );
    } else if (Array.isArray(value)) {
      // Handle array field errors
      value.forEach((item, index) => {
        if (item && typeof item === 'object') {
          messages.push(...flattenErrors(item, `${path}.${index}`, filterPath));
        }
      });
    }
  }

  return messages;
};
